import {
    GET_ACTIVE_DEVICES,
    GET_DEVICE_CHANNELS,
    SET_YH_ADDRESS,
    SET_YH_PORT,
    SET_MONITOR_DEVICE,
    SET_CHANNEL_LIST,
    SET_HISTORICAL_DEVICES,
    HISTORICAL_DEVICES_LOADING,
    DATA_QUALITY_LOADING,
    ACTIVE_DEVICE_LOADING,
    SET_START_MONITORING,
    SET_ACTIVE_WELLS,
    SET_HISTORICAL_DATAVIEWER_TOTAL_ROWS,
    SET_HISTORICAL_DATAVIEWER_TOTAL_PAGES,
    RIG_WELL_DATA,
    HISTORICAL_DATAVIEWER_LOADING,
    SET_HISTORICAL_DATAVIEWER_HEADER,
    SET_DATA_QUALITY_TOTAL_RECORD,
    SET_DATA_QUALITY_TIME,
    SET_HISTORICAL_DATAVIEWER,
    SET_GET_LOG,
    SET_CONFIGURAION_DATA,
    SET_GET_CONFIGURAION_DATA,
    SET_DATA_LOG_MNEMONIC,
    SET_DATA_CHANNEL_TEMPLATE,
    SET_DATA_ASPECT_TEMPLATE,
    SET_DATA_ASPECT_DAY_TEMPLATE,
    GET_CARD_DATA,
    SET_RAW_DATA,
    SET_RAW_TOTAL_RECORD,
    WELL_DATAPROVIDER_DATA,
    SET_DATE_DATAPROVIDER,
    GET_REPORT_FILTER_DATA,
    GET_REPORT_DATA,
    GET_COLOR_DATA,
    SET_AUDIT_LIST,
    SET_DATA_ASPECT_DAY_TOTAL_RECORDS,
    GET_CARD_DATA_TOTALRECORD,
    GET_SYNC_LIST,
    GET_SYNC_ACTION,
    GET_SYNC_DOWNLOAD
} from "../constants/action-types";

const initialState = {
    activeDevices: [],
    deviceChannels: [],
    deviceTotalChannel: {},
    deviceBadChannel: {},
    mnemonicValueConfig: [],
    configurationAllData: {},
    getconfigurationAllData:{},
    criticalChannelsProfileConfig: [],
    startMonitoring: localStorage.getItem("startMonitoring")
        ? JSON.parse(localStorage.getItem("startMonitoring"))
        : true,

    yhAddress: localStorage.getItem("yhAddress")
        ? JSON.parse(localStorage.getItem("yhAddress"))
        : "",
    yhPort: localStorage.getItem("yhPort")
        ? JSON.parse(localStorage.getItem("yhPort"))
        : 443,
    refreshInterval: localStorage.getItem("refreshInterval")
        ? JSON.parse(localStorage.getItem("refreshInterval"))
        : 30000,

    rigState: {},
    monitorDevice: {},
    historicalDataViewer: [],
    historicalHeader: [],
    monitorRig: {},
    channelList: {},
    monitorChannel: {},
    monitorThreshold: {},
    monitorDeadChannelThreshold: {},
    monitoringProfiles: [],
    rigTotalChannels: {},
    rigBadChannels: {},
    selectedProfile: localStorage.getItem("selectedProfile")
        ? JSON.parse(localStorage.getItem("selectedProfile"))
        : "Default",
    historicalDevices: {},
    connectionHistory: [],
    backfillHistory: [],
    connectionHistoryLoading: false,
    historicalDeviceLoading: false,
    dataQualityLoading: false,
    historicalDataViewerLoading: false,
    historicalDataLoading: false,
    historicalData: [],
    historicalDataTotalRows: 0,
    historicalDataTotalPages: 0,
    historicalDataViewerTotalRows: 0,
    historicalDataViewerTotalPages: 0,
    dataQualityTotalRecord: {},
    dataQualityTime: {},
    activeDevicesLoading: "notstarted",
    deviceChannelsLoading: {},
    activeWells: {},
    connectionData: {},
    rigWellData: {},
    rigCardData: [],
    getLog: {},
    dataQualityTotalRecordNew:{},
    logMnemonicData:{},
    ChannelTemplateRecords:{},
    aspectTemplateRecords:{},
    aspectTemplateDayRecords:[],
    aspectRawData:{},
    aspectRawTotalRecord:0,
    wellProviderData: {},
    dataProviderAll:{},
    thresholdColorsDqi:{},
    auditValue:{},
    aspectdayTotalRecords:0,
    wellcardTotalRecords: 0,
    getSyncData: {},
    getSyncAction: {},
    getSyncDownload: {},
};

const yh = (state = initialState, action) => {
    switch (action.type) {
        
        case GET_SYNC_DOWNLOAD:
            return {
                ...state,
                getSyncDownload: action.payload,
            }
        case GET_SYNC_ACTION:
            return {
                ...state,
                getSyncAction: action.payload,
            }
        case GET_SYNC_LIST:
            return {
                ...state,
                getSyncData: action.payload,
            }
        case GET_CARD_DATA_TOTALRECORD:
            return {
                ...state,
                wellcardTotalRecords: action.payload,
            }
        case SET_DATA_ASPECT_DAY_TOTAL_RECORDS:
            return {
                ...state,
                aspectdayTotalRecords: action?.payload,
            }
            case SET_AUDIT_LIST:
                return {
                    ...state,
                    auditValue: action?.payload,
                }
        case SET_DATE_DATAPROVIDER:
            return {
                ...state,
                dataProviderAll: action?.payload,
            }
            case GET_COLOR_DATA:
            return {
                ...state,
                thresholdColorsDqi: action?.payload,
            }
            
        case WELL_DATAPROVIDER_DATA:
            return {
                ...state,
                wellProviderData: action?.payload,
            }
            case SET_RAW_TOTAL_RECORD:
                return {
                    ...state,
                    aspectRawTotalRecord: action?.payload,
                }
            case SET_RAW_DATA:
                return {
                    ...state,
                    aspectRawData: action?.payload,
                }
        case SET_DATA_ASPECT_TEMPLATE:
            return {
                ...state,
                aspectTemplateRecords: action?.payload,
            }
            case SET_DATA_ASPECT_DAY_TEMPLATE:
                return {
                    ...state,
                    aspectTemplateDayRecords: action?.payload,
                }
        case SET_DATA_CHANNEL_TEMPLATE:
            return {
                ...state,
                ChannelTemplateRecords: action?.payload,
            }
            case SET_DATA_LOG_MNEMONIC:
            return {
                ...state,
                logMnemonicData: action?.payload,
            }
            case SET_DATA_QUALITY_TOTAL_RECORD:
                return {
                    ...state,
                    dataQualityTotalRecordNew: action?.payload,
                }
        case SET_GET_LOG:
            return {
                ...state,
                getLog: action?.payload,
            }


        case SET_DATA_QUALITY_TIME:
            return {
                ...state,
                dataQualityTime: action?.payload,
            };
        case SET_CHANNEL_LIST:
            return {
                ...state,
                channelList: action.payload,
            };
        case SET_HISTORICAL_DATAVIEWER_HEADER:
            return {
                ...state,
                historicalHeader: action.payload,
            };
        case SET_HISTORICAL_DATAVIEWER:
            return {
                ...state,
                historicalDataViewer: action.payload,
            };

        case SET_HISTORICAL_DATAVIEWER_TOTAL_ROWS:
            return {
                ...state,
                historicalDataViewerTotalRows: action.payload,
            };

        case SET_HISTORICAL_DATAVIEWER_TOTAL_PAGES:
            return {
                ...state,
                historicalDataViewerTotalPages: action.payload,
            };
        case HISTORICAL_DATAVIEWER_LOADING:
            return {
                ...state,
                historicalDataViewerLoading: action.payload,

            };
        case RIG_WELL_DATA:
            return {
                ...state,
                rigWellData: action.payload,
            };
        case GET_CARD_DATA:
            return {
                ...state,
                rigCardData: action.payload,
            };

        case SET_START_MONITORING:
            return {
                ...state,
                startMonitoring: action.payload,
            };

        case GET_ACTIVE_DEVICES:
            return {
                ...state,
                activeDevices: action.payload,
            };
        case GET_DEVICE_CHANNELS:
            return {
                ...state,
                deviceChannels: action.payload,
            };

        case SET_YH_ADDRESS:
            return {
                ...state,
                yhAddress: action.payload,
            };
        case SET_YH_PORT:
            return {
                ...state,
                yhPort: action.payload,
            };

        case SET_MONITOR_DEVICE:
            return {
                ...state,
                monitorDevice: action.payload,
            };

        case SET_HISTORICAL_DEVICES:
            return {
                ...state,
                historicalDevices: action.payload,
            };

        case HISTORICAL_DEVICES_LOADING:
            return {
                ...state,
                historicalDeviceLoading: action.payload,
            };
        case DATA_QUALITY_LOADING:
            return {
                ...state,
                dataQualityLoading: action.payload,
            };
        case ACTIVE_DEVICE_LOADING:
            return {
                ...state,
                activeDevicesLoading: action.payload,
            };

        case SET_ACTIVE_WELLS:
            return {
                ...state,
                activeWells: action.payload,
            };

        case SET_CONFIGURAION_DATA:
            return {
                ...state,
                configurationAllData: action.payload,
            }
        case SET_GET_CONFIGURAION_DATA:
            return{
                ...state,
                getconfigurationAllData: action.payload,
            }
        
        case GET_REPORT_FILTER_DATA:
            return{
                ...state,
                reportFilterData: action.payload,
            }
    
        case GET_REPORT_DATA:
            return{
                ...state,
                reportData: action.payload, 
            }

        default:
            return {
                ...state,
            };
    }
};

export default yh;